import { Fragment } from "react";

import { FormWrapper } from "@dzambalaorg/mui-form";
import { TextArea } from "@dzambalaorg/mui-inputs-core";
import { useApiCall } from "@dzambalaorg/react-hooks";
import { Breadcrumbs, PageHeader } from "@dzambalaorg/mui-page-layout";
import { FormGrid } from "@dzambalaorg/ui-kit";

import { validationSchema } from "./validation";

export const Feedback = () => {
  const { fn } = useApiCall((api, data) => {
    return api
      .fetchJson({
        url: "/feedback",
        method: "POST",
        data,
      })
      .then(console.info);
  });

  const handleSubmit = async (values: { test: string }, form: any) => {
    await fn(form, values);
  };

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "feedback"]} />

      <PageHeader message={"pages.feedback.title"} />

      <FormWrapper
        initialValues={{
          text: "",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
        showPrompt={false}
        testId="FeedbackForm"
      >
        <FormGrid
          columns={[1]}
          containerProps={{ sx: theme => ({ marginBottom: theme.spacing(theme.tokens.spacing.xl) }) }}
        >
          <TextArea name="text" />
        </FormGrid>
      </FormWrapper>
    </Fragment>
  );
};
